export default __webpack_public_path__ + "static/media/BreveText-Book.d04a2158.woff";